export default "__VITE_ASSET__ClgbnzyA__"